import {RouteView, PageView} from '../layouts'

export const user = {
    path: '/user',
    name: 'BaseForm',
    component: PageView,
    meta: {title: '用户管理', icon: 'user', isMenuShow: true, permission: 'user'},
    children: [
        {
            path: '/user/list',
            name: 'userList',
            component: () => import('../views/user/userList.vue'),
            meta: {title: '用户列表', keepAlive: false, isMenuShow: true, permission: 'user:list'},
            children: []
        },
        {
            path: '/user/detail',//用户信息面板
            name: 'userPanel',
            component: () => import('../views/user/userDetail/panel.vue'),
            redirect: "/user/details",
            meta: {
                title: '用户详情',
                from: {path: '/user/list', name: "用户列表"},
                keepAlive: false,
                isMenuShow: false,
                permission: 'user:list:detail'
            },
            children: [
                {
                    path: '/user/details',
                    components: {
                        base: () => import('../views/user/userDetail/base.vue'),//基本信息
                        medal: () => import('../views/user/userDetail/medal.vue'),//勋章信息
                        car: () => import('../views/user/userDetail/car.vue'),//车辆信息
                        // integral: () => import('../views/user/userDetail/integral.vue'),//积分明细
                        rescueorders: () => import('../views/user/userDetail/rescueorders.vue'),//救援订单
                        reservationorders: () => import('../views/user/userDetail/reservationorders.vue'),//预约订单
                        shopOrder: () => import('../views/user/userDetail/shopOrder.vue'),//商城订单
                        friend: () => import('../views/user/userDetail/friend.vue'),//好友列表
                        fans: () => import('../views/user/userDetail/fans.vue'),//粉丝列表
                        follow: () => import('../views/user/userDetail/follow.vue'),//关注列表
                        collect: () => import('../views/user/userDetail/collect.vue'),//收藏列表
                        sign: () => import('../views/user/userDetail/sign.vue'),//签到记录
                        invite: () => import('../views/user/userDetail/invite.vue'),//邀请记录
                        posts: () => import('../views/user/userDetail/posts.vue'),//帖子列表
                        comment: () => import('../views/user/userDetail/comment.vue'),//评论列表
                    },
                    meta: { title: '用户详情', keepAlive: false,isMenuShow:true},
                },
            ],
        },
        {
            path: '/user/details/addCar',
            name: 'addCar',
            component: () => import('../views/user/userDetail/addCar.vue'),
            meta: {title: '添加车辆', from: {path: '/user/list', name: "用户列表"}, keepAlive: false, isMenuShow: false},
        },
        {
            path: '/user/auth',
            name: 'authList',
            component: () => import('../views/user/authList.vue'),
            meta: {title: '电车认证记录', keepAlive: false, isMenuShow: true, permission: "user:audit"},
        },
        {
          path: '/user/gasoline',
          name: 'gasolineList',
          component: () => import('../views/user/gasolineList.vue'),
          meta: {title: '油车认证记录', keepAlive: false, isMenuShow: true, permission: "user:oilAudit"},
        },
        {
          path: '/user/personal',
          name: 'personalReal',
          component: () => import('../views/user/realName/personalReal.vue'),
          meta: {title: '个人实名认证', keepAlive: false, isMenuShow: true, permission: "user:oilAudit"},
        },
        {
          path: '/user/enterprise',
          name: 'enterpriseReal',
          component: () => import('../views/user/realName/enterpriseReal.vue'),
          meta: {title: '企业实名认证', keepAlive: false, isMenuShow: true, permission: "user:oilAudit"},
        },
        {
          path: '/user/flowManages',
          name: 'flowManage',
          component: () => import('../views/user/realName/panel.vue'),
          meta: {title: '流量管理-实销', keepAlive: false, isMenuShow: true, permission: "user:oilAudit"},
          children: [
              {
                  path: '/user/flowManages',
                  meta: {title: '', keepAlive: false, isMenuShow: true, permission: "user:oilAudit"},
                  components: {
                      rechargeConf: () => import('../views/user/realName/rechargeConf.vue'),// 流量配置
                      flowRechargingResults: () => import('../views/user/realName/flowRechargingResults.vue'),//流量充值结果
                      taxiBlacklist: () => import('../views/user/realName/taxiBlacklist.vue')//出租车黑名单
                  }
              }
          ]
        },
        {
          name: 'flowRecharge',
          path: '/user/flowRecharges',
          component: () => import('../views/user/realName/flowPanel.vue'),
          meta: {title: '流量管理-充值', keepAlive: false, isMenuShow: true, permission: "user:oilAudit"},
          children: [
              {
                  path: '/user/flowRecharges',
                  meta: {title: '', keepAlive: false, isMenuShow: true, permission: "user:oilAudit"},
                  components: {
                      orderList: () => import('../views/user/realName/orderList.vue'),// 流量充值记录
                      trafficConfiguration: () => import('../views/user/realName/trafficConfiguration.vue'),//流量充值配置
                  }
              }
            ]
        },
        {
          path: '/user/cCarList',
          name: 'cCarList',
          component: () => import('../views/user/cCarList.vue'),
          meta: {title: 'C62激活记录', keepAlive: false, isMenuShow: true, permission: "user:crecord"},
        },
        {
            path: '/user/medal',
            name: 'medal',
            component: () => import('../views/user/medal/panel.vue'),
            redirect: "/user/medal/medalList",
            meta: {title: '勋章管理', keepAlive: false, isMenuShow: true, permission: 'user:modal'},
            children: [
                {
                    path: '/user/medal/medalList',
                    name: 'medalList',
                    component: () => import('../views/user/medal/medalList.vue'),
                    meta: {title: '勋章列表', keepAlive: false, isMenuShow: true, tabPage: true, permission: 'user:modal'},
                },
                {
                    path: '/user/medal/userList',
                    name: 'userList',
                    component: () => import('../views/user/medal/userList.vue'),
                    meta: { title: '用户列表', keepAlive: false,isMenuShow:true,tabPage:true},
                }
            ]
        },
        {
            path: '/user/unbindRecord',
            name: 'userUnbindRecord',
            component: () => import('../views/user/unbindList.vue'),
            meta: {title: '解绑记录', keepAlive: false, isMenuShow: true, permission: 'user:unbind'},//user:unbind
            children: []
        },
        {
            path: '/user/modifyTel',
            name: 'modifyTel',
            component: () => import('../views/user/modifyTel.vue'),
            meta: {title: '修改手机号', keepAlive: false, isMenuShow: false, permission: 'user:unbind'},//user:unbind
            children: []
        },
        {
            path: '/user/medalUserList',
            name: 'medalUserList',
            component: () => import('../views/user/medal/medalUserList.vue'),
            meta: {
                title: '用户明细',
                from: {path: '/user/medal', name: "勋章管理"},
                keepAlive: false,
                isMenuShow: false,
                permission: 'user:modal:detail'
            },
        },
        {
            path: '/user/invite',
            name: 'invite',
            component: () => import('../views/user/invite/panel.vue'),
            redirect: "/user/invite/inviteRecord",
            meta: {title: '邀请管理', keepAlive: false, isMenuShow: true, permission: 'user:invite'},
            children: [
                {
                    path: '/user/invite/inviteList',
                    name: 'inviteList',
                    component: () => import('../views/user/invite/inviteList.vue'),
                    meta: {title: '邀请列表', keepAlive: false, isMenuShow: true, tabPage: true, permission: 'user:invite'},
                },
                {
                    path: '/user/invite/inviteRecord',
                    name: 'inviteRecord',
                    component: () => import('../views/user/invite/inviteRecord.vue'),
                    meta: {title: '邀请记录', keepAlive: false, isMenuShow: true, tabPage: true, permission: 'user:invite'},
                }
            ]
        },
        {
            path: '/operation/leads',
            name: 'adLanding',
            meta: {title: '用户线索', keepAlive: false, isMenuShow: true, permission: 'user:clue'},//user:clue
            component: PageView,
            redirect: '/operation/leads/list',
            children: [
                {
                    path: '/operation/leads/list',
                    name: 'leadsList',
                    component: () => import('../views/user/leadsList.vue'),
                    meta: {title: '', keepAlive: false, isMenuShow: true, permission: 'user'},
                },
            ]
        },
        {
            path: '/user/wakeup',
            name: 'wakeup',
            component: () => import('../views/user/userWakeup'),
            meta: { title: '用户唤醒', icon: 'dollar', isMenuShow: true, permission: 'user:wakeup' },
        },
        {
            path: '/user/wakeupHistory',
            name: 'wakeupHistory',
            component: () => import('../views/user/wakeupHistory'),
            meta: { title: '唤醒历史', icon: 'dollar', isMenuShow: false, permission: 'user:wakeup' },
        },
        {
            path: '/user/superAccount',
            name: 'superAccount',
            component: () => import('../views/user/superAccount'),
            meta: { title: '超级账号', icon: 'dollar', isMenuShow: true, permission: 'user:superAccount' },
        },
    ]
}


